<template>
  <section>
    <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
      <schoolsCardSection :data="data.schoolCategoryData"></schoolsCardSection>
    </div>
  </section>
  <section>
    <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
      <h2 class="f3 text-bold">DISCOVER SCHOOLS IN {{data.neighInfo.displayName}}</h2>
      <schoolsTable :data="data.schools" />
      <div class="flex center" v-html="data.paginationHTML"></div>
      <div>
          School data provided by
          <a class="link" href="https://www.greatschools.org/" rel="nofollow">GreatSchools.org</a>.
          See a school you’re interested in? Get matched with a top local Real Estate agent and start touring homes nearby.
      </div>
    </div>
  </section>
  <section v-if="data.dataList && data.dataList.length" v-for="(list, index) in data.dataList">
    <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
      <mvtCollapsibleLinks
          :title="list.title"
          titleClass="f3 text-capitalize text-bold p-y-2"
          :links='formatDataList(list.data)'
          :key="index"
          :initialExpandedState="true"
      />
    </div>
  </section>
</template>

<script src="./schools-neighbourhood.js"></script>
